export class Account {
    nroCuenta: string;
    nombre: string;

    constructor(nroCuenta: string, nombre: string) {
        this.nroCuenta = nroCuenta;
        this.nombre = nombre;
    }
}
